[
 {
  "id": "back",
  "x": 16,
  "y": 14,
  "w": 120,
  "h": 108
 },
 {
  "id": "sound",
  "x": 812,
  "y": 14,
  "w": 120,
  "h": 108
 },
 {
  "id": "logo",
  "x": 286,
  "y": 8,
  "w": 418,
  "h": 254
 },
 {
  "id": "sticker.ul",
  "x": 36,
  "y": 136,
  "w": 164,
  "h": 160
 },
 {
  "id": "sticker.ur",
  "x": 730,
  "y": 146,
  "w": 210,
  "h": 154
 },
 {
  "id": "sticker.r",
  "x": 800,
  "y": 480,
  "w": 140,
  "h": 126
 },
 {
  "id": "hero",
  "x": 0,
  "y": 226,
  "w": 941,
  "h": 478
 },
 {
  "id": "title",
  "x": 80,
  "y": 704,
  "w": 820,
  "h": 188
 },
 {
  "id": "cells",
  "x": 88,
  "y": 940,
  "w": 768,
  "h": 154
 },
 {
  "id": "join",
  "x": 52,
  "y": 1116,
  "w": 836,
  "h": 166
 },
 {
  "id": "scan",
  "x": 72,
  "y": 1298,
  "w": 796,
  "h": 130
 }
]